const plural = d => (d > 1 ? 's' : '');

export default plural;
